import {
	ADD_CREDIT_NOTE,
	CLEAN_REDUCER,
	CLEAR_SESSION,
	GET_CREDIT_NOTE,
	GET_CREDIT_NOTES,
	UPDATE_PAGE,
	UPDATE_SEARCH,
} from './actionTypes';

const initState = {
	creditNotes: [],
	creditNote: {},
	search: '',
	page: 1,
};

const reducer = (state = initState, action) => {
	switch (action.type) {
		case UPDATE_SEARCH:
			return {
				...state,
				search: action.search,
			};
		case UPDATE_PAGE:
			return {
				...state,
				page: action.page,
			};
		case GET_CREDIT_NOTES:
			return {
				...state,
				creditNotes: action.creditNotes,
			};
		case GET_CREDIT_NOTE:
			return {
				...state,
				creditNote: action.creditNote,
			};
		case ADD_CREDIT_NOTE:
			return state;
		case CLEAN_REDUCER:
			return initState;
		case CLEAR_SESSION:
			return initState;
		default:
			return state;
	}
};

export default reducer;
